import React, { useRef, useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { ConfirmModal } from 'components';

const ImgVideoUploaderCommon = ({ onFileSelect, subTitle, modalTitle, modalSubtitle, setShowIcons }: any) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [filePreview, setFilePreview] = useState<string | null>(null);
    const [fileName, setFileName] = useState<string | null>(null);
    const [fileType, setFileType] = useState<string | null>(null);
    const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);

    const handleCloseModal = () => setConfirmModalOpen(false);

    const handleAddDegree = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const fileURL = URL.createObjectURL(file);
            setFilePreview(fileURL);
            setFileName(file.name);
            setFileType(file.type);
            onFileSelect(file); // Pass the selected file to the parent component
        }
    };

    const handleDelete = () => {
        setConfirmModalOpen(true);
    };

    const handleConfirm = () => {
        // Your confirm logic here
        setFilePreview(null);
        setFileName(null);
        setFileType(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        // Update the icon state to false after deletion
        setShowIcons((prevState: any) => ({
            ...prevState,
            contentthumbnail: false,  // Hide the icon when the file is deleted
        }));
        setConfirmModalOpen(false);
    };

    return (
        <>
            {!filePreview ? (
                <Box
                    sx={styleSheet.mainContainer}
                >
                    <>
                        <CloudUploadIcon sx={{ fontSize: 40, color: '#666' }} />
                        <Typography variant="body1" sx={{ marginTop: 1 }}>
                            Drag & Drop or choose files to upload
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666', marginTop: 1 }}>
                            {subTitle}
                        </Typography>
                        <Button
                            variant="contained"
                            sx={{
                                marginTop: 2, backgroundColor: '#233F91', color: '#fff', borderRadius: '15px',
                                width: '215px', height: "57px", mt: 2
                            }}
                            onClick={handleAddDegree}
                        >
                            Browse File
                        </Button>
                        <input
                            type="file"
                            accept="image/*,video/*,application/pdf"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                    </>
                </Box>
            ) : (
                <Box pl="8px" display="flex" justifyContent="space-between" alignItems="center" sx={{
                    width: { xs: "321px", md: '563px' },
                    border: '2px dashed #ccc',
                    borderRadius: '8px',
                    height: "51px"

                }}>
                    <Box display={"flex"} alignItems={"center"}>
                        <InsertDriveFileIcon color='disabled' />
                        <Typography variant="body2" fontSize={18}
                            fontWeight={700} color={"#595959"}>
                            {fileName} ({fileType})
                        </Typography>
                    </Box>

                    <IconButton onClick={handleDelete} sx={{
                        marginRight: 1,
                        color: "#E10A0A"
                    }}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
            )}
            <ConfirmModal
                title={modalTitle}
                subtitle={modalSubtitle}
                cancelText="Cancel"
                confirmText="Confirm"
                titleColor="#020303"
                isLoading={false}
                onCancel={handleCloseModal}
                onConfirm={handleConfirm}
                isConfirmModal={isConfirmModalOpen}
                warning='Warning'
            />
        </>
    );
};

export default ImgVideoUploaderCommon;

const styleSheet = {
    mainContainer: {
        border: '2px dashed #ccc',
        width: { xs: '100%', md: '563px' },
        height: '276px',
        borderRadius: '8px',
        padding: '16px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        backgroundColor: '#f9f9f9'
    }
}
